import React from 'react';
import { Input } from 'antd';

const FieldTreeEntity = ({value, onChange, style={}, allowClear, disabled, ...rest}) => {
    return <Input style={{ ...style, width: '100%' }} value={value} onChange={e => onChange(e.target.value)} allowClear={allowClear} disabled={disabled} {...rest} />
}

export default FieldTreeEntity;